var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dashboard-block" },
      [
        _vm.fetchingNotifications
          ? _c("pickstar-loading", { staticClass: "m-t-lg" })
          : _vm._e(),
        _vm._v(" "),
        _vm.haveNoNotifications
          ? _c("no-results", [
              _c("div", [_vm._v("There are no notifications.")]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "item-detail list-links" },
          _vm._l(_vm.notifications, function (notification) {
            return _c("notification-feed-item", {
              key: notification.id,
              attrs: { notification: notification },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "lazy-loading",
          {
            ref: "lazyLoading",
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              "reached-bottom": _vm.handleGetNextNotificationsCallback,
            },
          },
          [
            _c("pickstar-loading", {
              attrs: { slot: "loading" },
              slot: "loading",
            }),
            _vm._v(" "),
            _c("span", { attrs: { slot: "finished" }, slot: "finished" }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("\n        Notifications\n      ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }